import { render, staticRenderFns } from "./VerifiedSingleSelect.vue?vue&type=template&id=452c9f05"
import script from "./VerifiedSingleSelect.vue?vue&type=script&lang=js"
export * from "./VerifiedSingleSelect.vue?vue&type=script&lang=js"
import style0 from "./VerifiedSingleSelect.vue?vue&type=style&index=0&id=452c9f05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports